import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import {
  defaultTellingen,
  type EnvironmentSettings,
  type LinkItem,
} from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Instellingen, {
  isVisible: () => true,
  create: (settings: EnvironmentSettings): LinkItem => {
    const tellingen = settings.tellingen ?? defaultTellingen;
    const heeftSpfMeldingen = settings.isInstellingsRechten && !!tellingen.spfMeldingen;

    return {
      itemtype: 'link',
      menuItem: MenuItems.Instellingen,
      title: 'Instellingen',
      url: '/content/beheer/tussenpersoon/',
      iconclass: 'far fa-cog',
      showbadge: heeftSpfMeldingen,
      badgecontent: heeftSpfMeldingen ? '1' : undefined,
    };
  },
});
